import type { NavAccountType } from "@admin-ui/components/primitives/application/app-navigation/base-components/nav-account-card";
import type {
  NavItemDividerType,
  NavItemType,
} from "@admin-ui/components/primitives/application/app-navigation/config";
import { SidebarNavigationSectionDividers } from "@admin-ui/components/primitives/application/app-navigation/sidebar-navigation/sidebar-section-dividers";
import {
  adminAccountsPath,
  adminDestinationsPath,
  adminListingsPath,
  adminLocationsPath,
  adminProgramsPath,
  adminUsersPath,
  adminWorldSourcesPath,
} from "@travily/routes";
import { BookOpen01, Building01, Globe01, Server04, ShoppingBag03, Users01 } from "@untitledui/icons";
import type { ReactNode } from "react";

export type { NavAccountType };

export interface AdminLayoutProps {
  children: ReactNode;
  activeUrl?: string;
  account: NavAccountType;
}

const navItems: (NavItemType | NavItemDividerType)[] = [
  { label: "Users", href: adminUsersPath(), icon: Users01 },
  { label: "Accounts", href: adminAccountsPath(), icon: Building01 },
  { divider: true },
  {
    label: "Marketplace",
    icon: ShoppingBag03,
    items: [{ label: "Listings", href: adminListingsPath() }],
  },
  {
    label: "World",
    icon: Globe01,
    items: [
      { label: "Destinations", href: adminDestinationsPath() },
      { label: "Locations", href: adminLocationsPath() },
      { label: "Knowledge sources", href: adminWorldSourcesPath() },
    ],
  },
  {
    label: "Programs",
    icon: BookOpen01,
    items: [{ label: "All programs", href: adminProgramsPath() }],
  },
  { divider: true },
  // Mission Control is a Rails engine, not an Inertia page. Force `external` so the
  // sidebar Link bypasses Inertia's SPA router (memory: external links via target="_blank").
  { label: "Jobs", href: "/admin/jobs", icon: Server04, external: true },
];

export function AdminLayout({ children, activeUrl, account }: AdminLayoutProps) {
  return (
    <div className="min-h-screen bg-primary lg:flex">
      <SidebarNavigationSectionDividers activeUrl={activeUrl} items={navItems} showSearch={false} account={account} />

      <main className="min-w-0 flex-1 overflow-auto bg-secondary pt-8 pb-12 lg:bg-primary">{children}</main>
    </div>
  );
}
